import { auth } from '../firebase';

/**
 * Salinan jadwal shift di Supabase (dipakai pengingat presensi masuk/pulang,
 * lihat api/notify/[name].js) diperbarui otomatis dari penanda
 * `jadwal_diperbarui`. Dokumen yang DIHAPUS tidak bisa diberi penanda, jadi
 * aplikasi memberi tahu server lewat fungsi ini. Tanpa `hapusGrup`/`hapusGuru`
 * = salin ulang penuh (khusus super admin).
 */
export const mintaSinkronJadwal = async (body: { hapusGrup?: string; hapusGuru?: string } = {}) => {
    const idToken = await auth.currentUser?.getIdToken();
    const res = await fetch('/api/notify/sinkron-jadwal', {
        method: 'POST',
        headers: { Authorization: `Bearer ${idToken || ''}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || `Server menjawab ${res.status}.`);
    return data as { mode?: string; grup?: number; pegawai?: number; dihapus?: string };
};

/** Versi best-effort untuk setelah menghapus dokumen: gagal pun tidak mengganggu. */
export const hapusDariSalinanJadwal = (body: { hapusGrup?: string; hapusGuru?: string }) => {
    mintaSinkronJadwal(body).catch(err => console.warn('Salinan jadwal belum diperbarui (otomatis dirapikan saat sinkron mingguan):', err));
};

export interface SaklarPengingat {
    aktif: boolean;
    diubah_oleh: string | null;
    diubah_pada: string | null;
    liburMingguan: boolean;
}

/** Baca (tanpa argumen) atau ubah saklar pengingat presensi masuk & pulang. Khusus super admin. */
export const saklarPengingat = async (aktif?: boolean): Promise<SaklarPengingat> => {
    const idToken = await auth.currentUser?.getIdToken();
    const res = await fetch('/api/notify/pengaturan-pengingat', {
        method: 'POST',
        headers: { Authorization: `Bearer ${idToken || ''}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(typeof aktif === 'boolean' ? { aktif } : {}),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || `Server menjawab ${res.status}.`);
    return data as SaklarPengingat;
};
